import { render, staticRenderFns } from "./v-contact-card.vue?vue&type=template&id=5d92d0e6&scoped=true&"
import script from "./v-contact-card.vue?vue&type=script&lang=js&"
export * from "./v-contact-card.vue?vue&type=script&lang=js&"
import style0 from "./v-contact-card.vue?vue&type=style&index=0&id=5d92d0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d92d0e6",
  null
  
)

export default component.exports